import NodeInformationPage from '../implementations/Node/InformationPage';
import NodeTextPage from '../implementations/Node/TextPage';
import NodeLandingsPage from '../implementations/Node/LandingsPage';
import NodeColleague from '../implementations/Node/Colleague';
import NodeFrontPage from '../implementations/Node/FrontPage';
import NodeVacancy from '../implementations/Node/Vacancy';
import NodeEvent from '../implementations/Node/Event';

const mappers = {
  colleague: NodeColleague,
  front_page: NodeFrontPage,
  information_page: NodeInformationPage,
  text_page: NodeTextPage,
  landings_page: NodeLandingsPage,
  vacancy: NodeVacancy,
  event: NodeEvent,
};

export default mappers;
